// source: mlmbox/types/status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.mlmbox.types.Status', null, global);
goog.exportSymbol('proto.mlmbox.types.Status.Auth', null, global);
goog.exportSymbol('proto.mlmbox.types.Status.Confirmation', null, global);
goog.exportSymbol('proto.mlmbox.types.Status.ConfirmationForm', null, global);
goog.exportSymbol('proto.mlmbox.types.Status.GoogleAuthenticator', null, global);
goog.exportSymbol('proto.mlmbox.types.Status.GoogleAuthenticatorVerifiedCode', null, global);
goog.exportSymbol('proto.mlmbox.types.Status.Referral', null, global);
goog.exportSymbol('proto.mlmbox.types.Status.TokenValidate', null, global);
goog.exportSymbol('proto.mlmbox.types.Status.Transaction', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.types.Status = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.types.Status, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.types.Status.displayName = 'proto.mlmbox.types.Status';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.types.Status.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.types.Status.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.types.Status} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.types.Status.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.types.Status}
 */
proto.mlmbox.types.Status.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.types.Status;
  return proto.mlmbox.types.Status.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.types.Status} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.types.Status}
 */
proto.mlmbox.types.Status.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.types.Status.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.types.Status.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.types.Status} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.types.Status.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.mlmbox.types.Status.Auth = {
  AUTH_GUEST: 0,
  AUTH_SIGN_IN: 1,
  AUTH_SIGN_UP: 2
};

/**
 * @enum {number}
 */
proto.mlmbox.types.Status.Referral = {
  REFERRAL_UNKNOWN: 0,
  REFERRAL_WRONG_LINK: 1,
  REFERRAL_BUSY: 2,
  REFERRAL_EXISTS: 3
};

/**
 * @enum {number}
 */
proto.mlmbox.types.Status.TokenValidate = {
  TOKEN_VALIDATE_UNKNOWN: 0,
  TOKEN_VALIDATE_ACTIVATED: 1,
  TOKEN_VALIDATE_EXPIRED: 2,
  TOKEN_VALIDATE_INVALID: 3
};

/**
 * @enum {number}
 */
proto.mlmbox.types.Status.GoogleAuthenticator = {
  GOOGLE_AUTHENTICATOR_DEACTIVATED: 0,
  GOOGLE_AUTHENTICATOR_ACTIVATED: 1,
  GOOGLE_AUTHENTICATOR_REQUESTED: 2
};

/**
 * @enum {number}
 */
proto.mlmbox.types.Status.GoogleAuthenticatorVerifiedCode = {
  GOOGLE_AUTHENTICATOR_VERIFIED_CODE_UNKNOWN: 0,
  GOOGLE_AUTHENTICATOR_VERIFIED_CODE_APPROVED: 1,
  GOOGLE_AUTHENTICATOR_VERIFIED_CODE_REJECTED: 2,
  GOOGLE_AUTHENTICATOR_VERIFIED_CODE_WRONG_CODE: 3
};

/**
 * @enum {number}
 */
proto.mlmbox.types.Status.Confirmation = {
  CONFIRMATION_ACTIVATED: 0,
  CONFIRMATION_APPROVED: 1,
  CONFIRMATION_REJECT: 2,
  CONFIRMATION_CANCELED: 3,
  CONFIRMATION_EXPIRED: 4
};

/**
 * @enum {number}
 */
proto.mlmbox.types.Status.ConfirmationForm = {
  CONFIRMATION_FORM_REJECTED: 0,
  CONFIRMATION_FORM_APPROVED: 1
};

/**
 * @enum {number}
 */
proto.mlmbox.types.Status.Transaction = {
  TRANSACTION_PROCESSING: 0,
  TRANSACTION_SUCCESS: 1,
  TRANSACTION_REJECTED: 2
};

goog.object.extend(exports, proto.mlmbox.types);
